const activatePositionFillRequestValidation = {
  recruitmentPoolId: {
    type: 'enum',
    required: true,
  },
};

export default activatePositionFillRequestValidation;
